import swal from 'sweetalert'
import 'sweetalert/dist/sweetalert.css'
import {COLOR_NAVY} from '../constants'

export const alert = (msg)=>{
  swal({
    title: msg,
    // type:'info',
    confirmButtonColor: COLOR_NAVY
  })
}

export const alertSuccess = (title, text = "", confirmFunction)=>{
  swal({
    title, text,
    type:'success',
    confirmButtonColor: COLOR_NAVY
  }, confirmFunction)
}

export const alertWarning = (title, text = "", confirmFunction)=>{
  swal({
    title, text,
    type:'warning',
    confirmButtonColor: COLOR_NAVY
  }, confirmFunction)
}

export const confirm = (title, text = "", confirmButtonText, confirmFunction, type = 'warning')=>{
  swal({
    title, text, type,
    showCancelButton: true,
    confirmButtonColor: COLOR_NAVY,
    confirmButtonText,
    closeOnConfirm: true
  }, confirmFunction)
}



// WEBPACK FOOTER //
// ./src/util/AlertUtil.js